import { NrlkAPI } from './api.js';

export class NrlkAdmin {
  constructor(entreprise, token = null) {
    this.api = new NrlkAPI(entreprise, token);
  }

  setEntreprise(entreprise) { this.api.setEntreprise(entreprise); }
  setToken(token) { this.api.setToken(token); }

  async getMoyensFacturation() {
    return this.api.get('/extranet/ticket/facturations');
  }

  async getTypesTicket() {
    return this.api.get('/extranet/ticket/types');
  }

  async getCouleurs() {
    return this.api.get('/couleur');
  }
}
